"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SeleniumBrowserValidate = exports.SeleniumBrowserValidateOrThrow = void 0;
var SeleniumBrowsers_1 = require("../models/SeleniumBrowsers");
var SeleniumBrowserValidateOrThrow = function (browserName, browserVersion) {
    var browserConfig = SeleniumBrowsers_1.SeleniumBrowsers[browserName];
    if (!browserConfig) {
        throw new Error("Browser " + browserName + " is not supported!");
    }
    if (browserConfig.versions.includes(browserVersion) === false) {
        throw new Error("Browser " + browserName + " does not support version " + browserVersion + ".");
    }
    return true;
};
exports.SeleniumBrowserValidateOrThrow = SeleniumBrowserValidateOrThrow;
var SeleniumBrowserValidate = function (browserName, browserVersion) {
    try {
        return exports.SeleniumBrowserValidateOrThrow(browserName, browserVersion);
    }
    catch (error) {
        return false;
    }
};
exports.SeleniumBrowserValidate = SeleniumBrowserValidate;
